exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-img{filter:brightness(0) invert(1)}.error-message{color:red}.badge-local{background-color:#000;color:#fff}.badge-pedidos{background-color:red;color:#fff}.badge-uber{background-color:#03a732;color:#fff}.badge-wsp{background-color:#02e01f;color:#fff}", ""]);

// exports
